import { render, staticRenderFns } from "./CallTab.vue?vue&type=template&id=3f78596d&"
import script from "./CallTab.vue?vue&type=script&lang=js&"
export * from "./CallTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports